import { lazy } from 'react';

import type { RouteObject } from 'react-router-dom';

const NavigateToInstanceModal = lazy(
  () =>
    import('@/pages/Configuration/environmentConfigurations/components/modal/NavigateToInstanceModal'),
);

const ProjectManagementLandingPage = lazy(
  () =>
    import('@/pages/Configuration/projectManagement/ProjectManagementLandingPage'),
);

const UpdateApprovalVersion = lazy(
  () =>
    import('@/pages/Configuration/projectManagement/approvalVersion/update/UpdateApprovalVersion'),
);

export const ProjectManagementRoutes: RouteObject[] = [
  {
    path: '/configuration/project-management/*',
    element: <ProjectManagementLandingPage />,
    children: [
      {
        path: 'defect-management/navigate-to-instance/:selectedPlugIn',
        element: <NavigateToInstanceModal />,
      },
      {
        path: 'approval-version/edit-drawer/:userId/:projectName',
        element: <UpdateApprovalVersion />,
      },
    ],
  },
];
